// extracted by mini-css-extract-plugin
module.exports = {"container":"Settings_container__2O5gg","profile":"Settings_profile__iXZQN","header":"Settings_header__1fCZg","settingsEditIcon":"Settings_settingsEditIcon__1EUiZ"};